import { useState, useEffect } from 'react'
import { BJFLogo } from './PriceIndicator.logo'
import { Arrow } from './PriceIndicator.arrow'
import { LinkContainer, Price, PriceChange, PriceInfo, Sector, TokenName } from './PriceIndicator.styled'
import { Spinner } from '../spinner'
import { interval } from 'rxjs'
import { fetchQuery, graphql } from 'relay-runtime'
import Env from '../../RelayEnvironment'
import { PriceIndicatorQuery } from './__generated__/PriceindicatorQuery.graphql'

export const getFiatRatesV2Query = graphql`
  query PriceIndicatorQuery {
    fiatRatesV2 {
      currency
      priceUsd
      percentChangeLastDay
    }
  }
`

interface PriceIndicatorProps {
  isCollapsed: boolean
  isMobile?: boolean
}

const PriceIndicator = ({ isCollapsed, isMobile = false }: PriceIndicatorProps) => {
  const [data, setData] = useState({ price: 0, percent: 0 })
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState('')

  useEffect(() => {
    setLoading(true)

    const getFiatRates = () => {
      fetchQuery<PriceIndicatorQuery>(Env, getFiatRatesV2Query, {}).subscribe({
        next: (response) => {
          if (response) {
            const bjfRate = response.fiatRatesV2.find((rate) => rate.currency === 'BJF')
            setData({
              price: bjfRate?.priceUsd || 0,
              percent: bjfRate?.percentChangeLastDay || 0,
            })
            setLoading(false)
          }
        },
        error: (error) => {
          console.error('Error fetching fiat rates:', error)
          setError(error.message)
          setLoading(false)
        },
        complete: () => {
          setLoading(false)
        },
      })
    }

    const fiatSubscription = interval(200 * 1000).subscribe(() => {
      getFiatRates()
    })

    getFiatRates()

    return () => {
      fiatSubscription.unsubscribe()
    }
  }, [])

  if (error) {
    return null
  }

  if (loading) {
    return (
      <LinkContainer to="/bjf-token" $isMobile={isMobile}>
        <BJFLogo isCollapsed={isCollapsed} loading={loading}></BJFLogo>
        {!isCollapsed && loading && <Spinner />}
      </LinkContainer>
    )
  }

  if (!data.price || isCollapsed) {
    return null
  }

  const isPositive = data.percent >= 0

  return (
    <LinkContainer to="/bjf-token" $isMobile={isMobile}>
      <BJFLogo isCollapsed={isCollapsed} />
      <PriceInfo>
        <Sector $isCollapsed={isCollapsed}>
          <TokenName>Blackjack.fun</TokenName>
          <TokenName>(BJF)</TokenName>
        </Sector>
        <Sector $isCollapsed={isCollapsed}>
          <Price>${data.price.toFixed(6)}</Price>
          <PriceChange $isCollapsed={isCollapsed} $isPositive={isPositive}>
            <Arrow isCollapsed={isCollapsed} isArrowUp={isPositive} />
            {Math.abs(Number(data.percent.toFixed(2)))}%
          </PriceChange>
        </Sector>
      </PriceInfo>
    </LinkContainer>
  )
}

export default PriceIndicator
